import React from 'react';
import PropTypes from 'prop-types';

import EmailVerificationCTA from 'components/EmailVerificationCTA';

import styles from './index.scss';

function NotificationEmailVerificationCTA({ className, email, iconURL, text }) {
  return (
    <EmailVerificationCTA
      email={email}
      className={`clearfix btn default ${styles.wrapper} ${className}`}
    >
      <img
        src={iconURL}
        data-src={iconURL}
        className="avatar-img avatar"
        alt={text}
      />
      <div className="text-caption1">{text}</div>
    </EmailVerificationCTA>
  );
}

NotificationEmailVerificationCTA.propTypes = {
  className: PropTypes.string,
  email: PropTypes.string.isRequired,
  iconURL: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

NotificationEmailVerificationCTA.defaultProps = {
  className: ''
};

export default NotificationEmailVerificationCTA;
